export const INVITE_SESSION_CLEARED_KEY = 'td:auth-session-cleared';
